<nz-card nzTitle="File Assignment" [nzLoading]="loading()" style="margin-top: 15px;">
  <nz-row [nzGutter]="[16, 16]">
    @for (spec of allRenderSpecs(); track spec.key) {
      <nz-col [nzSpan]="12">
        <div
          class="file-role-card"
          [style.border-left-color]="spec.color ?? defaultColor">

          <div class="file-role-header">
            <span
              nz-icon
              [nzType]="spec.icon ?? defaultIcon"
              nzTheme="outline"
              class="role-icon"
              [style.color]="spec.color ?? defaultColor">
            </span>
            <span class="role-label">{{ spec.label }}</span>
            @if (spec.required) {
              <span class="required-dot" nz-tooltip nzTooltipTitle="Required">*</span>
            }
            @if (spec.key.startsWith('extra_')) {
              <button
                nz-button nzType="text" nzSize="small" nzDanger
                (click)="removeExtra(spec.key)"
                style="margin-left: auto; padding: 0 4px;">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
              </button>
            }
          </div>

          @if (spec.sourceFromJob) {
            <app-job-volume-picker
              [jobs]="jobs()"
              [defaultJob]="templateJob()"
              [fileRegex]="spec.regex"
              [defaultSelectionRegex]="spec.defaultSelectionRegex"
              (selectionChange)="setJobVolumeSelection(spec.key, $event)">
            </app-job-volume-picker>
          } @else {
            <nz-select
              style="width: 100%"
              [ngModel]="fileSelections()[spec.key]"
              (ngModelChange)="setSelection(spec.key, $event)"
              nzShowSearch
              nzAllowClear
              [nzPlaceHolder]="spec.regex ? 'Filtered by /' + spec.regex + '/' : 'Search and select...'">
              @for (file of spec | filesFor:allFiles():runfiles(); track file.path) {
                <nz-option [nzValue]="file" [nzLabel]="file.name" [nzTitle]="file.path"></nz-option>
              }
              @empty {
                <nz-option nzDisabled nzValue="" nzLabel="No matching files found"></nz-option>
              }
            </nz-select>

            <div class="custom-path-row">
              <span class="custom-path-label">or enter path manually</span>
              <input
                nz-input
                nzSize="small"
                class="custom-path-input"
                [ngModel]="customPaths()[spec.key] ?? ''"
                (ngModelChange)="setCustomPath(spec.key, $event)"
                placeholder="/s3/path/to/file" />
            </div>
          }

          <div class="rename-row">
            <span class="rename-label">Output name</span>
            <input
              nz-input
              nzSize="small"
              class="rename-input"
              [ngModel]="fileRenames()[spec.key] ?? ''"
              (ngModelChange)="setRename(spec.key, $event)"
              placeholder="output-filename.sgy" />
          </div>

          @if (customPaths()[spec.key]; as custom) {
            <div class="selected-indicator custom" nz-tooltip [nzTooltipTitle]="custom">
              <span nz-icon nzType="edit" nzTheme="outline"></span>
              {{ custom }}
            </div>
          } @else if (fileSelections()[spec.key]; as sel) {
            <div class="selected-indicator" nz-tooltip [nzTooltipTitle]="sel.path">
              <span nz-icon nzType="check-circle" nzTheme="fill"></span>
              {{ sel.name }}
            </div>
          }

        </div>
      </nz-col>
    }
  </nz-row>

  <div style="margin-top: 12px; display: flex; justify-content: flex-end;">
    <button nz-button nzType="dashed" (click)="addFile()">
      <span nz-icon nzType="plus"></span>
      Add Extra File
    </button>
  </div>
</nz-card>
